import React, { useContext } from "react";

import { PrivateRoutes } from "../../config/routes";
import {
	EntryContext,
	EntryGlobalActionTypes,
} from "../../contexts/EntryContext";
import CreateEditHeader from "./header/CreateEditHeader";
import CreateEditSidebar from "./sidebar/CreateEditSidebar";
import { Box, useDisclosure } from "@chakra-ui/react";
import SubmitCancelReturnModal from "../SubmitCancelReturnModal";
import { Outlet, useNavigate } from "react-router-dom";

const EditEntryLayout: React.FC = () => {
	const navigate = useNavigate();
	const {
		state: { steps },
		dispatch,
	} = useContext(EntryContext);
	const { isOpen, onOpen, onClose } = useDisclosure();

	const handleBackClick = () => {
		if (steps.stepWho.changesMade || steps.stepWhere.changesMade) {
			onOpen();
		} else {
			handleCancelClick();
		}
	};

	const handleCancelClick = () => {
		dispatch({
			type: EntryGlobalActionTypes.INITIALIZE_ENTRY,
		});
		navigate(PrivateRoutes.MATCHING_SYSTEM);
	};

	return (
		<>
			<CreateEditHeader handleBackClick={handleBackClick} />
			<CreateEditSidebar
				steps={steps}
				type="edit_entry"
				title="Edit Matching Entry"
				handleBackClick={handleBackClick}
			/>
			<Box
				width={["100%", "100%", "calc(100% - 300px)"]}
				marginLeft={["0px", "0px", "300px"]}
				minHeight="100%"
				backgroundColor="brand.appBackground"
				padding={{ base: "200px 0px 20px 0px", md: "100px 20px 20px 20px" }}
				as="main"
				display="flex"
				flexDir="column"
				alignItems="center"
				position="relative"
				backgroundRepeat="none"
				backgroundSize="cover"
			>
				<Box maxWidth="900px" width="100%">
					<Outlet />
				</Box>
			</Box>

			<SubmitCancelReturnModal
				key="submitCancelReturnModal"
				formId="entry_form"
				cancelText={"Discard Changes"}
				headerText="If you have made changes and return to the dashboard without saving them, you will lose them."
				isOpen={isOpen}
				onClose={onClose}
				onCancel={handleCancelClick}
				isConfirming={false}
				returnText="Return to Entry"
				onReturn={onClose}
			/>
		</>
	);
};

export default EditEntryLayout;
